import HtmlCss from "../../../../src/components/html_css_example.js";
import { Link, withPrefix } from "gatsby";
import Repl from "../../../../src/components/js-repl.js";
import Code from "../../../../src/components/code.js";
import { exclamations } from "../../../../src/components/utils";
import * as React from 'react';
export default {
  HtmlCss,
  Link,
  withPrefix,
  Repl,
  Code,
  exclamations,
  React
};